import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import getObjectsAction from "../actions/get-objects.actions";
import { ObjectsState } from "domain/objects/entities/interfaces/object-state.interface";
import { buildObjectStatusLookup } from "app/data/helpers";
import { mapObjectsToMarkers } from "domain/objects/entities/mappers/map-objects-to-markers.mapper";

const getObjectsCases = (builder: ActionReducerMapBuilder<ObjectsState>) => {
  builder.addCase(getObjectsAction.pending, (state) => {
    state.isLoadingObjects = true;
  });
  builder.addCase(getObjectsAction.fulfilled, (state, action) => {
    const payload = action.payload || [];
    state.objectStatusesByUniqueId = buildObjectStatusLookup(payload);

    // Locations payload drives map objects/markers; GET /objects only enriches
    // status. Rebuild even when markers are empty (e.g. all inactive hidden).
    if (state.objects.length > 0) {
      state.markers = mapObjectsToMarkers(state.objects, {
        statusLookup: state.objectStatusesByUniqueId,
        showInactiveObjects: state.showInactiveObjects
      });
    }

    state.isLoadingObjects = false;
  });
  builder.addCase(getObjectsAction.rejected, (state) => {
    state.isLoadingObjects = false;
  });
};

export default getObjectsCases;
